/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Bpk.Abdul',
        title: 'Pasien Rawat Luka',
        text: "from Mr.Abdul: Perawatan luka progres kesembuhan sangat baik, dan kami sekeluarga mendapat edukasi untuk melakukan ganti balut mandiri, terima kasih Mohes from Ethan Shop.",
        image: boy2
    },
    {
        id: 2,
        name: 'Ibu Mey',
        title: 'Customer Rawat Luka',
        text: "@from Mey: terima kasih kepada staff Mohes from Ethan Shop yang menjadi advokat mensupport kesembuhan luka ibu Saya",
        image: girl2
    },
    {
        id: 3,
        name: 'Bpk Asep',
        title: 'Pasien',
        text: "Saya sudah sembuh, nyeri ulu hati dan lemas sudah tidak ada",
        image: girl1
    },
    {
        id: 4,
        name: 'Sdr. Riz..',
        title: 'Pasien',
        text: "Keluhan nyeri saat bak sudah hilang, dan hasil laborat bakteri Gonorea hasil negatif, antibiotik yang diberikan sangat manjur",
        image: boy1
    },
    {
        id: 5,
        name: 'Ibu Dewi',
        title: 'Ibu Pasien',
        text: ' terima kasih sudah merawat luka paska khitan anak saya, Ethan Shop staff dengan sabar dan teliti merawat luka bekas syatan khitan',
        image: girl3
    },
    {
        id: 6,
        name: 'Fauz...',
        title: 'Pasien Covid 19',
        text: "terima kasih saya bisa sembuh dan sehat, setelah terkena pademi covid dengan saturasi oksigen 74% dan semua rumah sakit penuh, saya di rawat di rumah oleh staff Mohes from Ethan Shop dan sekarang sudah pulih total…bisa beraktivitas seperti semula",
        image: boy3
    }
]

